import { ReactNode } from 'react';
import { useI18n } from '@react/i18n';
import { Spinner } from '../checkout/sections/ui';

interface Props {
    name: string;
    logoUrl: string | null;
    price: string | null;
    free: boolean;
    priceFrom?: boolean;
    /** HTML z DB (popis dopravy/platby) */
    descriptionHtml?: string | null;
    selected: boolean;
    disabled: boolean;
    /** důvod nedostupnosti („Nelze kombinovat s …") — karta zůstává klikatelná */
    unavailableHint?: string | null;
    pending: boolean;
    onSelect: () => void;
    children?: ReactNode;
}

/**
 * Řádek dopravy/platby — vizuálně navazuje na legacy .dp-box/.b-radio,
 * přidává plynulé přechody, spinner během ukládání a checkmark po výběru.
 */
export default function OptionCard(props: Props) {
    const t = useI18n();

    const classes = [
        'dpr-card',
        props.selected ? 'dpr-card--selected' : '',
        props.disabled ? 'dpr-card--disabled' : '',
        props.pending ? 'dpr-card--pending' : '',
    ].filter(Boolean).join(' ');

    return (
        <li className={classes}>
            {/* nedostupná volba není disabled v DOM — klik ji vybere a odebere
                konfliktní protistranu (resolveConflict), viz DeliveryPaymentStep */}
            <button
                type="button"
                className="dpr-card__btn"
                onClick={props.onSelect}
                disabled={props.pending}
                aria-disabled={props.disabled || undefined}
                aria-pressed={props.selected}
            >
                <span className="dpr-card__radio" aria-hidden="true">
                    {props.pending ? <Spinner className="dpr-card__spinner" /> : <span className="dpr-card__radio-dot" />}
                </span>

                {props.logoUrl ? (
                    <span className="dpr-card__logo">
                        <img src={props.logoUrl} alt={`${props.name} logo`} loading="lazy" />
                    </span>
                ) : null}

                <span className="dpr-card__body">
                    <span className="dpr-card__name">{props.name}</span>
                    {props.descriptionHtml
                        ? <span className="dpr-card__desc" dangerouslySetInnerHTML={{ __html: props.descriptionHtml }} />
                        : null}
                    {props.disabled && props.unavailableHint
                        ? <span className="dpr-card__conflict">{props.unavailableHint}</span>
                        : null}
                </span>

                <span className={`dpr-card__price${props.free ? ' dpr-card__price--free' : ''}`}>
                    {props.free
                        ? t('zdarma')
                        : <>{props.priceFrom ? `${t('od')} ` : ''}{props.price}</>}
                </span>
            </button>
            {props.children}
        </li>
    );
}
